import 'babel-polyfill'
import 'app.css'

import React from 'react'
import ReactDOM from 'react-dom'

import { Provider } from 'mobx-react'
import { Router, browserHistory } from 'react-router'

import routes from './routes'
import WebsitesStore from './stores/websites'
import Auth from './stores/auth'
import AuthLoading from './components/AuthLoading'

const auth = new Auth()
const websites = new WebsitesStore()

ReactDOM.render(
  <Provider auth={auth} websites={websites}>
    <AuthLoading auth={auth}>
      <Router history={browserHistory} children={routes(auth)} />
    </AuthLoading>
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// client/index.js